import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

let Status = new Vuex.Store({
    state: {
        isInit: true,
        isLoading: false,
        loadingCounter: 0,
        showInitialMsg: true
    },
    actions: {
        setLoading(context, isLoading) {
            if (typeof isLoading == "boolean") {
                context.commit('setLoading', isLoading);
            }
        },
        setInitialMsg(context, show) {
            context.commit('setInitialMsg', show);
        },
        setIsInit(context, isInit) {
            context.commit('setIsInit', isInit);
        }
    },
    mutations: {
        setLoading(state, isLoading) {
            if (isLoading === true) {
                state.loadingCounter++;
            } else {
                state.loadingCounter--;
            }

            if (state.loadingCounter < 1) {
                state.loadingCounter = 0;
                state.isLoading = false;
            } else {
                state.isLoading = true;
            }
        },
        setInitialMsg(state, show) {
            state.showInitialMsg = show;
        },
        setIsInit(state, isInit) {
            state.isInit = isInit;
        }
    },
    getters: {
        getStatus: state => {
            return state;
        },
        showInitialMsg: state => {
            return state.showInitialMsg;
        },
        isInit: state => {
            return state.isInit;
        }
    }
});

export default Status;